import {
  KEYWORD_GENERATOR_TOOL,
  ARTICLE_WRITER_TOOL,
  TITLE_GENERATOR_TOOL,
  IDEA_GENERATOR_TOOL,
  GRAMMAR_CHECKER_TOOL,
  STORY_GENERATOR_TOOL,
  AD_COPY_GENERATOR_TOOL,
  SOCIAL_MEDIA_BIO_TOOL,
  REPHRASER_TOOL,
  MARKETING_SLOGAN_TOOL,
  BUSINESS_NAME_TOOL,
  INSTAGRAM_HASHTAG_GENERATOR_TOOL,
  PRODUCT_DESCRIPTION_GENERATOR_TOOL,
  INSTAGRAM_CAPTION_TOOL,
  LANDING_PAGE_OUTLINE_TOOL,
  META_DATA_MAKER_TOOL,
  SUMMARIZER_TOOL,
  TRANSLATOR_TOOL,
  ESSAY_WRITER_TOOL,
  EMAIL_WRITER_TOOL,
  PROMPT_GENERATOR_TOOL,
  PARAGRAPH_GENERATOR_TOOL,
  VIDEO_SCRIPT_GENERATOR_TOOL,
  EXPAND_TEXT_TOOL,
  SHORTEN_TEXT_TOOL,
} from '@quicktools/shared-components/data/tools';

export enum CardCategory {
  All = 'all',
  Generate = 'generate',
  Edit = 'edit',
  Content = 'content',
  Business = 'business',
  Marketing = 'marketing',
}

export const cardCategoryToText = {
  [CardCategory.All]: 'All',
  [CardCategory.Generate]: 'Generate text',
  [CardCategory.Edit]: 'Edit text',
  [CardCategory.Content]: 'Content',
  [CardCategory.Business]: 'Business',
  [CardCategory.Marketing]: 'Marketing',
};

export const TOOLS = {
  [CardCategory.All]: [
    ARTICLE_WRITER_TOOL,
    EXPAND_TEXT_TOOL,
    TITLE_GENERATOR_TOOL,
    IDEA_GENERATOR_TOOL,
    KEYWORD_GENERATOR_TOOL,
    GRAMMAR_CHECKER_TOOL,
    VIDEO_SCRIPT_GENERATOR_TOOL,
    SHORTEN_TEXT_TOOL,
    STORY_GENERATOR_TOOL,
    AD_COPY_GENERATOR_TOOL,
    SOCIAL_MEDIA_BIO_TOOL,
    REPHRASER_TOOL,
    MARKETING_SLOGAN_TOOL,
    BUSINESS_NAME_TOOL,
    INSTAGRAM_HASHTAG_GENERATOR_TOOL,
    PRODUCT_DESCRIPTION_GENERATOR_TOOL,
    INSTAGRAM_CAPTION_TOOL,
    LANDING_PAGE_OUTLINE_TOOL,
    PROMPT_GENERATOR_TOOL,
    PARAGRAPH_GENERATOR_TOOL,
    META_DATA_MAKER_TOOL,
    SUMMARIZER_TOOL,
    TRANSLATOR_TOOL,
    ESSAY_WRITER_TOOL,
    EMAIL_WRITER_TOOL,
  ],
  [CardCategory.Generate]: [
    ARTICLE_WRITER_TOOL,
    EMAIL_WRITER_TOOL,
    ESSAY_WRITER_TOOL,
    IDEA_GENERATOR_TOOL,
    KEYWORD_GENERATOR_TOOL,
    VIDEO_SCRIPT_GENERATOR_TOOL,
    BUSINESS_NAME_TOOL,
    LANDING_PAGE_OUTLINE_TOOL,
    PROMPT_GENERATOR_TOOL,
    PARAGRAPH_GENERATOR_TOOL,
    STORY_GENERATOR_TOOL,
    TITLE_GENERATOR_TOOL,
    TRANSLATOR_TOOL,
  ],
  [CardCategory.Edit]: [
    EXPAND_TEXT_TOOL,
    GRAMMAR_CHECKER_TOOL,
    REPHRASER_TOOL,
    SHORTEN_TEXT_TOOL,
    SUMMARIZER_TOOL,
  ],
  [CardCategory.Content]: [
    ARTICLE_WRITER_TOOL,
    INSTAGRAM_CAPTION_TOOL,
    INSTAGRAM_HASHTAG_GENERATOR_TOOL,
    IDEA_GENERATOR_TOOL,
    KEYWORD_GENERATOR_TOOL,
    META_DATA_MAKER_TOOL,
    LANDING_PAGE_OUTLINE_TOOL,
    PARAGRAPH_GENERATOR_TOOL,
    SOCIAL_MEDIA_BIO_TOOL,
    STORY_GENERATOR_TOOL,
    VIDEO_SCRIPT_GENERATOR_TOOL,
    TITLE_GENERATOR_TOOL,
  ],
  [CardCategory.Business]: [BUSINESS_NAME_TOOL, EMAIL_WRITER_TOOL, MARKETING_SLOGAN_TOOL],
  [CardCategory.Marketing]: [
    AD_COPY_GENERATOR_TOOL,
    ARTICLE_WRITER_TOOL,
    EMAIL_WRITER_TOOL,
    KEYWORD_GENERATOR_TOOL,
    META_DATA_MAKER_TOOL,
    PARAGRAPH_GENERATOR_TOOL,
    PRODUCT_DESCRIPTION_GENERATOR_TOOL,
    MARKETING_SLOGAN_TOOL,
  ],
};
